import { render } from "./FieldPerformance.vue?vue&type=template&id=8ef80548"
import script from "./FieldPerformance.vue?vue&type=script&lang=js"
export * from "./FieldPerformance.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2025.48.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__